module.exports = __webpack_public_path__ + "static/media/(H)-05-Capim-Dourado-bijuterias.9cd01a3d.jpg";